import Text from 'antd/lib/typography/Text';
import Title from 'antd/lib/typography/Title';
import { useTranslation } from 'react-i18next';
import React from 'react';

const VolumeDiscountTooltipContent = ({ original, final, currency }) => {
  const { t } = useTranslation();
  return (
    <div style={{ textAlign: 'center' }}>
      <div>
        <strong>{t('Volume discount applied')}</strong>
      </div>
      <div>
        {t('Original CPM')}: {original} {currency}
      </div>
      <div>
        {t('Final CPM')}: {final} {currency}
      </div>
    </div>
  );
};

export default VolumeDiscountTooltipContent;
